import React, { Component } from 'react';
import './StreamingVideo.scss';
import Hls from "hls.js";
import { streamId, pattern } from '../../../services/subscriberService';
import PropTypes from 'prop-types';
import { CheckValue, videoThumbnail } from '../../../services/CommonFunction';
// import { cache } from 'sw-toolbox';
// import caches from '';
            
// var caches;
class NewStreamingVideo extends Component {

    state = {
        status: false,
        seeked: false,
        showIcon: true,
        disable: true,
        vid: null,
        videoSrc: null,
        hls: new Hls(),
        version: '?v=1.0'
    }

    componentDidUpdate = async( nextProps ) => {
        const src = this.checkSrc(nextProps.videoSrc);        
        if(this.state.videoSrc !== src) {
            // if(!this.state.status) {
            //     await this.videoControl();
            // }
            this.setState({ videoSrc: src });
            setTimeout(async () => {
                this.state.vid.load();
                setTimeout(() => {
                    this.setState({ disable: this.state.vid.readyState === 4 || src?false:true });
                    this.videoHlr(src);
                }, 500);
            }, 200);
        }
    }

    checkSrc = (src) => {
        if(!CheckValue(src)) {
            return src;
        }
        return typeof src === 'string'?src: src.value;
    }

    componentDidMount = async () => {
        await this.setState({ vid: document.getElementById(this.props.id) })
    }

    componentWillUnmount() {
        this.state.hls.destroy();
        // this.setState({
        //     vid: null,
        //     videoSrc: null,
        //     hls: null
        // })
        if(streamId.detail === this.props.id ) {
            streamId.sendData('');
        }
    }

    videoHlr = async (videoSrc, close = false) => {
        const obj = new RegExp(pattern.streamUrl);
        if (Hls.isSupported() && obj.test(videoSrc)) {
            const {hls, version} = this.state;
            const {id, show, addVersion} = this.props;
            const video = addVersion?videoSrc:videoSrc+version;
            hls.attachMedia(this.state.vid);
            hls.on(Hls.Events.MEDIA_ATTACHED, function() {
                hls.loadSource(video);
                hls.on(Hls.Events.MANIFEST_PARSED, function() {
                    if(!show) {
                        hls.startLoad(1);
                        this.state.vid.play();
                    }
                });
            });

            hls.on(Hls.Events.LEVEL_LOADED, function(event,data) {});
            hls.on(Hls.Events.ERROR, function(event,data) {
                console.error('error',id,data);
            });
            // hls.startLoad(1)
        } else if (this.state.vid.canPlayType('application/vnd.apple.mpegurl')) {
            this.state.vid.addEventListener('loadedmetadata', function() {
            //  video.play();
            });
        }
    }

    videoControl = () => {
        if(this.state.vid.readyState !== 0) {
            if(this.state.status) {
                if(streamId.detail !== '' ) {
                    document.getElementById(streamId.detail).pause();
                }
                streamId.sendData(this.props.id);
                this.state.vid.play();
            } else {
                streamId.sendData('');
                this.state.vid.pause();
            }
        }
    }

    videoThum = async (video) => {
        if(this.state.seeked) {
            const obj = new RegExp(pattern.streamUrl);
            this.setState({ seeked: false });
            video.currentTime = 0;
            if(obj.test(this.state.videoSrc)) {
                const canvas = document.createElement('canvas');
                canvas.style.display = 'none';
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                let imageUrl = canvas.toDataURL('image/png');
                this.props.setSeeked(imageUrl);
            } else {
                videoThumbnail(this.state.videoSrc,10).then(res => {
                    if(CheckValue(res)) {
                        this.props.setSeeked(res.localURL);
                    }
                })
            }
        }
    }

    render() {
        const { id, src, addVersion, setDuration, controls, mute, pause, currentDuration, loop, show } = this.props;
        const { videoSrc, disable, version, status } = this.state;
        let videoS = null;
        if(CheckValue(videoSrc)) {
            videoS = addVersion?videoSrc+version:videoSrc
        }
        return (
            <React.Fragment>
                <div className= {`videoTag${disable?" disable":""}`} >
                    <video 
                        id = {id}
                        preload="auto"
                        src={videoS} 
                        controls={controls}
                        autoPlay={!show}
                        muted={mute}
                        loop={loop}
                        onPlay={e => {
                            if(!status) {
                                this.setState({status: true});
                            }
                        }}
                        onPause={e => {
                            if(e.target.readyState ===  4) {
                                pause();
                                this.setState({status: false})
                            }
                        }}
                        onLoadedMetadata={e => {
                            this.setState({disable:false});
                            if(show) {
                                setDuration(e.target.duration);
                                this.setState({seeked: !CheckValue(src)});
                                if(!CheckValue(src)) {
                                    e.target.currentTime = e.target.duration > 5?5:e.target.duration;
                                }
                            } else {
                                if(currentDuration > e.target.duration) {
                                    e.target.currentTime = currentDuration % e.target.duration;
                                } else {
                                    e.target.currentTime = currentDuration;
                                }
                            }
                        }}
                        onLoadStart={e => this.setState({disable:true}) }
                        onSeeked={e => this.videoThum(e.target) }
                        poster = {src}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default NewStreamingVideo;

NewStreamingVideo.propTypes = {
    id: PropTypes.string.isRequired,
    style: PropTypes.object,
    src: PropTypes.string,
    videoSrc: PropTypes.string,
    videoPopup: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    customPlayer: PropTypes.bool.isRequired,
    controls: PropTypes.bool,
    mute: PropTypes.bool,
    loop: PropTypes.bool,
    currentDuration: PropTypes.number,
    pause: PropTypes.func,
    setSeeked: PropTypes.func,
    setDuration: PropTypes.func
}

NewStreamingVideo.defaultProps = {
    id: 'videoId',
    style: null,
    src: null,
    videoSrc: null,
    videoPopup: false,
    mute: false,
    show: true,
    currentDuration: 0,
    customPlayer: true,
    controls: false,
    loop: false,
    setDuration: () => null,
    setSeeked: () => null,
    pause: () => null
}